import { LanguageCode } from '@app/core/models/language.model';
import {
  SmsCustomKeywordEntry,
  SystemKeyword,
} from '@app/core/models/sms-custom-keyword';

/**
 * One language's full authoring state for a client (rn-portal
 * `GET .../sms-language-config/client-languages`): response text, whether it's
 * live (server-computed — never recomputed client-side), and the keywords that
 * trigger it.
 */
export interface ClientLanguageConfig {
  languageCode: LanguageCode;
  stopResponseText: string | null;
  helpResponseText: string | null;
  /** Server-computed: true only when both texts have non-whitespace text. Never set client-side. */
  enabled: boolean;
  /** Server-computed: ACTIVE once both responses have text. Only Active languages reach the SMS handler. */
  status: 'ACTIVE' | 'INCOMPLETE';
  systemKeywords: SystemKeyword[];
  customKeywords: SmsCustomKeywordEntry[];
}

export function deserializeClientLanguageConfig(
  input: object,
): ClientLanguageConfig {
  return {
    languageCode: input['languageCode'],
    stopResponseText: input['stopResponseText'] ?? null,
    helpResponseText: input['helpResponseText'] ?? null,
    enabled: input['enabled'] ?? false,
    status: input['status'] === 'ACTIVE' ? 'ACTIVE' : 'INCOMPLETE',
    systemKeywords: (input['systemKeywords'] ?? []).map((k: object) => ({
      languageCode: k['languageCode'],
      type: k['type'],
      keyword: k['keyword'],
    })),
    customKeywords: (input['customKeywords'] ?? []).map(
      SmsCustomKeywordEntry.deserialize,
    ),
  };
}

/** STOP/HELP text to save for one language; omitted fields are left as they are. */
export interface ClientLanguageTexts {
  languageCode: LanguageCode;
  stopResponseText?: string;
  helpResponseText?: string;
}
